import React from "react";

// `totalSteps` overrides the per-tab count for a caller whose flow differs:
// BookMeeting has three steps, while NewMeetingModal (same activeTab="meeting")
// keeps two and does not pass it.
const MeetingStepProgress = ({ step, activeTab, totalSteps: stepsOverride }) => {

  // define steps per tab
  const totalSteps = {
    parking: 2,
    desking: 2,
    meeting: 2
  };

  const steps = Number(stepsOverride) > 0 ? Number(stepsOverride) : (totalSteps[activeTab] || 2);

  // Clamp so sections past the last circle (the meeting confirmation and approval
  // screens) stay on it, instead of leaving no circle active.
  const activeIndex = Math.min(Math.max(Number(step) || 0, 0), steps - 1);

  return (
    <div className="position-relative step-progress">
      <div
        className="progress step-number d-flex"
        style={{ "--step-progress": steps > 1 ? activeIndex / (steps - 1) : 0 }}
      >
        {Array.from({ length: steps }).map((_, index) => (
          <span
            key={index}
            className={`progress-step${index < activeIndex ? " completed" : ""}${index === activeIndex ? " active" : ""}`}
          >
            {index + 1}
          </span>
        ))}

      </div>
    </div>
  );
};

export default MeetingStepProgress;